/** 이력·통계 공용 포맷 헬퍼. */

/**
 * 초 → 사람이 읽기 쉬운 지속 표시.
 *   "45초"  /  "3분 20초"  /  "1시간 5분"  /  "1일 3시간"  /  "7일"
 *
 * 24h 이상은 일+시간으로 묶어 분 단위 노이즈를 줄인다 (긴 incident 의 가독성).
 * 7일 이상도 동일 규칙으로 자연 확장됨.
 */
export function formatDuration(sec: number | null): string {
  if (sec == null) return "—";
  if (sec < 60) return `${sec}초`;
  const m = Math.floor(sec / 60);
  if (m < 60) {
    const s = sec % 60;
    return s ? `${m}분 ${s}초` : `${m}분`;
  }
  const h = Math.floor(m / 60);
  if (h < 24) {
    const mm = m % 60;
    return mm ? `${h}시간 ${mm}분` : `${h}시간`;
  }
  const d = Math.floor(h / 24);
  const hh = h % 24;
  return hh ? `${d}일 ${hh}시간` : `${d}일`;
}

/** "...T17:55:01+09:00" → "06/04 17:55". null → "진행 중". */
export function fmtTime(iso: string | null): string {
  if (!iso) return "진행 중";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** uptime% → 막대 색 클래스. */
export function uptimeColor(pct: number): string {
  if (pct >= 99.9) return "bg-status-operational dark:bg-status-operational-dark";
  if (pct >= 95) return "bg-status-degraded dark:bg-status-degraded-dark";
  return "bg-status-majorOutage dark:bg-status-majorOutage-dark";
}

/** 주차장 표시명 — lotName 우선, 없으면 lotId. */
export function lotLabel(lotName: string | null, lotId: string): string {
  return lotName && lotName.trim() ? lotName : lotId;
}
